import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fabric } from "fabric";
import { dataHandlers } from "../../utils/objectHandlers";
import { setZoom, saveState } from "../../Store/reducers/fabriccontrolsSlice";
import { handleDownload } from "../../utils/fabricHelper.js";
import { showPopup } from "../../Store/reducers/popUpSlice.js";
import {
  setFabricCanvas,
  setImageloaded,
  setPendingDownload,
} from "../../Store/reducers/fabricCanvasSlice";
import { setFabricCanvasAsImage } from "../../Store/reducers/svgSlice.jsx";
import { useLocation } from "react-router-dom";
import { fabricclampViewport } from "../customHooks/useZoomControls.jsx";
let BASE_WIDTH = 650;
let BASE_HEIGHT = 500;

const Canvas = () => {
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const pendingDownload = useSelector((state) => state.fabricCanvas.pendingDownload);
  const imageloaded = useSelector((state) => state.fabricCanvas.imageloaded);
  const canvasBackground = useSelector((state) => state.canvas.canvasAsImage);
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const canvasesState = useSelector((state) => state.canvasesstate.canvases);
  const { svgDetails } = useSelector((state) => state.svgDetails);
  const zoom = useSelector((state) => state.canvasesstate.zoom);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("product_id");
  const selectedMockup =
    useSelector((state) => state.mockupCategories.selectedMockup) || [];
  BASE_WIDTH = activeTab === "editMockup" ? selectedMockup?.width : 650;
  BASE_HEIGHT = activeTab === "editMockup" ? selectedMockup?.height : 500;
  const [isLoading, setIsLoading] = useState(false);

  // const [isImageAdded, setIsImageAdded] = useState(
  //     localStorage.getItem(`isImageAdded_${productId}`) === "true"
  // );

  // ---------------- Canvas Initialization ----------------
  useEffect(() => {
    const bgColor = activeTab === "editMockup" ? "transparent" : "#ffffff";
    const canvas = new fabric.Canvas("svg-editor", {
      // perPixelTargetFind:true,
      selection: true,
      preserveObjectStacking: true,
      backgroundColor: bgColor,
        
                   
    });

    // Set default properties for Fabric objects.
    fabric.Object.prototype.set({
      cornerColor: "black",
      cornerStyle: "circle",
      
      transparentCorners: false,
      borderColor: "black",
      borderScaleFactor: 2,
    });

    // Panning state.
    let isPanning = false;
    let lastPosX = 0;
    let lastPosY = 0;
    const defaultZoom = 1;

    const handleMouseDown = (event) => {
      const currentZoom = canvas.getZoom();
      if (event.e.which === 1 && event.e.ctrlKey) {
        if (currentZoom > defaultZoom) isPanning = true;
        canvas.setCursor("grab");
      }
      canvas.selection = true;
      lastPosX = event.e.clientX;
      lastPosY = event.e.clientY;
    };

    const handleMouseMove = (event) => {
      if (!isPanning) return;
      const { clientX, clientY } = event.e;
      const deltaX = clientX - lastPosX;
      const deltaY = clientY - lastPosY;
      canvas.relativePan(new fabric.Point(deltaX, deltaY));
      lastPosX = clientX;
      lastPosY = clientY;
      fabricclampViewport(canvas);
    };

    const handleMouseUp = () => {
      isPanning = false;
      canvas.selection = true;
      canvas.defaultCursor = "default";
      fabricclampViewport(canvas);
    };

    canvas.on("mouse:down", handleMouseDown);
    canvas.on("mouse:move", handleMouseMove);
    canvas.on("mouse:up", handleMouseUp);

    // Create a variable to track the hovered object.
    let hoveredObject = null;

    // On mouse:over, set the hovered object (only if no active objects exist)
    canvas.on("mouse:over", (event) => {
      const { target } = event;
      if (canvas.getActiveObjects().length) {
        return;
      }
      if (target instanceof fabric.Object && !(target instanceof Array)) {
        hoveredObject = target;
        canvas.renderAll();
      }
    });

    // On mouse:out, clear the hovered object.
    canvas.on("mouse:out", (event) => {
      hoveredObject = null;
      canvas.renderAll();
    });

    // Optionally, clear hovered object when the mouse leaves the entire canvas.
    canvas.wrapperEl.addEventListener("mouseleave", () => {
      hoveredObject = null;
      canvas.renderAll();
    });

    // In the after:render event, first clear the overlay context, then draw the bounding box if needed.
   canvas.on("after:render", () => {
  if (
    hoveredObject &&
    canvas.getActiveObjects().indexOf(hoveredObject) === -1
  ) {
    const ctx = canvas.getContext('2d'); // safer than contextTop for hover
    const bound = hoveredObject.getBoundingRect();

    ctx.save();
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    // ctx.setLineDash([5, 3]);
    ctx.strokeRect(bound.left, bound.top, bound.width, bound.height);
    ctx.restore();
  }
});


    // Adjust canvas size based on window dimensions.
    const adjustCanvasSize = () => {
      const availableWidth = window.innerWidth - 700;
      const availableHeight = window.innerHeight - 150;
      const baseWidth = BASE_WIDTH;
      const baseHeight = BASE_HEIGHT;
      const scaleX = availableWidth / baseWidth;
      const scaleY = availableHeight / baseHeight;
      const scale = Math.min(scaleX, scaleY);
      canvas.setZoom(1);
      canvas.setDimensions({
        width: baseWidth * scale,
        height: baseHeight * scale,
      });
      dispatch(setZoom(1));
      canvas.renderAll();
    };

    adjustCanvasSize();
    window.addEventListener("resize", adjustCanvasSize);

    canvasRef.current = canvas;
    window.fabCanvas = canvas;

    // Load saved canvas state, if any.
    // const savedState =  localStorage.getItem(`${activeTab}CanvasState_${productId}`);
    const savedState = canvasesState[`${activeTab}CanvasState`]?.currentState;

    if (savedState) {
      const savedStatParsed = JSON.parse(savedState)
      console.log("before parsed json",savedStatParsed )
      if(savedStatParsed?.backgroundImage){
       delete savedStatParsed.backgroundImage
       console.log("updated json",savedStatParsed)
      }
      console.log("json",savedState)
      let updatedSavedState = JSON.stringify(savedStatParsed);
      canvas.loadFromJSON(updatedSavedState, () => {
        canvas.renderAll();
      });
    }
   
    dispatch(setFabricCanvas(canvas));

    return () => {
      window.removeEventListener("resize", adjustCanvasSize);
      canvas.off("mouse:down", handleMouseDown);
      canvas.off("mouse:move", handleMouseMove);
      canvas.off("mouse:up", handleMouseUp);
      canvas.dispose();
    };
  }, [activeTab, dispatch, productId]);

  // ---------------- Save Canvas State ----------------
  const saveCanvasState = useCallback(() => {
    if (!fabricCanvas) return;
    // Skip saving if we're in the middle of loading a previous state.
    if (fabricCanvas.__isLoadingState) return;

    const canvasState = JSON.stringify(fabricCanvas.toJSON(["protected"]));
    dispatch(saveState({ tab: `${activeTab}CanvasState`, canvasState }));

    if (activeTab === "editSVG") {
      const canvasJSON = JSON.stringify(fabricCanvas.toJSON(["protected"]));
      console.log("scg canvas json",canvasJSON)
      dispatch(setFabricCanvasAsImage(canvasJSON));
    }

    if (fabricCanvas._objects && fabricCanvas.contextTop) {
      fabricCanvas.renderAll();
    }
  }, [fabricCanvas, activeTab, dispatch]);

  useEffect(() => {
    if (fabricCanvas) {
      fabricCanvas.on("object:added", saveCanvasState);
      fabricCanvas.on("object:modified", saveCanvasState);
      fabricCanvas.on("object:removed", saveCanvasState);
    }
    return () => {
      if (fabricCanvas) {
        fabricCanvas.off("object:added", saveCanvasState);
        fabricCanvas.off("object:modified", saveCanvasState);
        fabricCanvas.off("object:removed", saveCanvasState);
      }
    };
  }, [fabricCanvas]);

  // ---------------- Set Background for "editMockup" ----------------
  const setBackgroundFromBlob = useCallback(async () => {
    if (!canvasBackground || !fabricCanvas) return;
  console.log("updated canvas bg",canvasBackground)
    // Create a flag to track if the component is still mounted
    let isMounted = true;
    setIsLoading(true); 
    const img = new Image();
    img.src = canvasBackground;
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      // If the component has unmounted, do nothing.
      if (!isMounted || !fabricCanvas.lowerCanvasEl) return;

      fabric.Image.fromURL(img.src, (fabricImg) => {
        if (!isMounted || !fabricCanvas.lowerCanvasEl) return;

        const { naturalWidth, naturalHeight } = img;
        const scaleX = fabricCanvas.width / naturalWidth;
        const scaleY = fabricCanvas.height / naturalHeight;
        fabricCanvas.setBackgroundImage(
          fabricImg,
          () => {
            if (!isMounted || !fabricCanvas.lowerCanvasEl) return;
            fabricCanvas.renderAll();
            saveCanvasState();
          
            // setTimeout(() => {
              let updatedCanvasState = JSON.stringify(fabricCanvas.toJSON());
            pendingDownload &&   handleDownload("editMockup",fabricCanvas,updatedCanvasState, ()=>{
                dispatch (setPendingDownload(false));
            });
          // }, 100);
          },
          {
            scaleX,
            scaleY,
            originX: "left",
            originY: "top",
          }
        );
       
      });
    };

    // Cleanup function to cancel the asynchronous operation if needed.
    return () => {
      isMounted = false;
    };
  }, [canvasBackground, fabricCanvas, zoom, saveCanvasState,pendingDownload]);


  
  useEffect(() => {
    if (!fabricCanvas) return;
    if (activeTab === "editMockup" && canvasBackground) {
      setBackgroundFromBlob().catch((error) =>
        console.error("Error setting canvas background:", error)
      );
    }
  }, [activeTab, canvasBackground, fabricCanvas, setBackgroundFromBlob]);

  // ---------------- Load SVG into Canvas (for editSVG) ----------------
  useEffect(() => {
    if (!fabricCanvas || activeTab === "editMockup") return;
    
    if (imageloaded) return; // imageloaded comes from Redux and persists

    const files = svgDetails?.data?.downloadable_files;
    if (!files) {
      console.error("No SVG files found in svgDetails");
      return;
    }
    const key = Object.keys(files)[0];
    const svgUrl = files[key]?.file;
    if (!svgUrl) {
      console.error("No SVG URL found in svgDetails");
      return;
    }
    fabric.loadSVGFromURL(svgUrl, (objects, options) => {
      const svgGroup = fabric.util.groupSVGElements(objects, options);
      svgGroup.svgLoaded = true;
   
   // ——— Begin resizing logic ———
   const canvasWidth = fabricCanvas.getWidth();
   const canvasHeight = fabricCanvas.getHeight();
   const minSize = 300; 

   const originalWidth  = options.width;
   const originalHeight = options.height;

   // how much to scale to fit both dims
   const widthRatio  = canvasWidth  / originalWidth;
   const heightRatio = canvasHeight  / originalHeight;
   let scale = Math.min(widthRatio, heightRatio);

   let newWidth  = originalWidth  * scale;
   let newHeight = originalHeight * scale;

   // if both sides ended up too small, bump scale up
   if (newWidth < minSize && newHeight < minSize) {
     const minWidthScale  = minSize / originalWidth;
     const minHeightScale = minSize / originalHeight;
     scale = Math.max(minWidthScale, minHeightScale);

     newWidth  = originalWidth  * scale;
     newHeight = originalHeight * scale;

     // if that overshoots the canvas, clamp back
     
     if (newWidth > canvasWidth || newHeight > canvasHeight) {
       const maxWidthScale  = canvasWidth  / originalWidth;
       const maxHeightScale = canvasHeight  / originalHeight;
       scale = Math.min(maxWidthScale, maxHeightScale);

       newWidth  = originalWidth  * scale;
       newHeight = originalHeight * scale ;
     }
   }

   svgGroup.scaleX = svgGroup.scaleY = scale - 0.1 ;
      // svgGroup.scaleToHeight(400);
      console.log("svggroup",svgGroup)
      svgGroup.set({
        left: fabricCanvas.width / 2 ,
        top: fabricCanvas.height / 2 ,
        originX: "center",
        originY: "center",
        padding: 0,
        selectable: true,
        protected:true,
      });
      fabricCanvas.add(svgGroup);
      fabricCanvas.renderAll();
      saveCanvasState();
      dispatch(setImageloaded(true)); 
      console.log("inside svg pending download",pendingDownload )
      
      pendingDownload &&   handleDownload("editSVG",fabricCanvas,canvasesState, ()=>{
          dispatch (setPendingDownload(false));
      });
    });
  }, [
    fabricCanvas,
    activeTab,
    svgDetails,
    dispatch,
    imageloaded,
    saveCanvasState,
    pendingDownload,
  ]);

  // useEffect(() => {
  //   if (!fabricCanvas ) return;
  
  //   // Create a manual flag for grouping
  //   fabricCanvas._isGrouping = false;
  
  //   const originalRemove = fabricCanvas.remove;
  
  //   fabricCanvas.remove = function (...objects) {
  //     // Don't show popup during grouping
  //     if (this._isGrouping) {
  //       return originalRemove.apply(this, objects);
  //     }
  
  //     for (const obj of objects) {
  //       if (obj.type === "group" && obj._objects?.some(child => child.protected)) {
  //         dispatch(showPopup("This Group Contains a Protected Svg"));
  //         return false; 
  //       }
  
  //       if (obj.protected) {
  //         dispatch(showPopup("This Svg Cannot be Deleted"));
  //         return false;
  //       }
  //     }
  
  //     return originalRemove.apply(this, objects);
  //   };
  
  //   return () => {
  //     fabricCanvas.remove = originalRemove;
  //   };
  // }, [fabricCanvas]);
  


  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     localStorage.removeItem(`isImageAdded_${productId}`);
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, [productId]);

  // ---------------- Drag & Drop Handlers ----------------
  const handleDrop = async (e) => {
    e.preventDefault();
    if (!fabricCanvas) return;
    const pointer = fabricCanvas.getPointer(e);
    const keys = ["font", "image", "svg", "svgFile"];
    for (let key of keys) {
      const data = e.dataTransfer.getData(key);
      if (data && dataHandlers[key]) {
        const customProps = { left: pointer.x, top: pointer.y };
        await dataHandlers[key](data, fabricCanvas, customProps);
        saveCanvasState();
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div className="flex-1 flex justify-center items-center">
      <div
        className="flex justify-center items-center"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <canvas id="svg-editor" />
      </div>
    </div>
  );
};

export default Canvas;
